import AccountPreferences from "./AccountPreferences";

export default AccountPreferences;
